import type { TeamMemberRow } from '../../masterdependency/framework';

type Props = { members?: TeamMemberRow[] };

export function DependencyTeamPanel({ members = [] }: Props) {
  return (
    <div className="space-y-2">
      {members.map((m) => (
        <div key={m.role} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{m.role}</p>
          <p className="mt-1 text-xs text-slate-500">{m.responsibility}</p>
          <p className="mt-0.5 text-xs font-medium text-brand-600">{m.focus}</p>
        </div>
      ))}
    </div>
  );
}
